import React from 'react';
import PropTypes from 'prop-types';

class SelectAttribute extends React.Component {

  onChange = (event) => {
    this.props.onFieldValueChange(this.props.keyPath, event.target.value);
  };

  onFocus = () => {
    this.props.onFieldUIStateChange(this.props.keyPath, { touched: true, focused: true });
  };

  onBlur = () => {
    this.props.onFieldUIStateChange(this.props.keyPath, { focused: false, touched: true, hasLostFocusOnce: true });
  };

  createOptions = (options) => {
    if (Array.isArray(options)) {
      if (this.props.sortOptions) {
        options.sort((a, b) => a.localeCompare(b));
      }
      return options.map((option) => (
        <option
          key={option}
          value={option}
        >
          {option}
        </option>
      ));
    }
    const optionKeys = Object.keys(options);
    if (this.props.sortOptions) {
      optionKeys.sort((a, b) => options[a].localeCompare(options[b]));
    }
    const optionJSXArray = optionKeys.map((optionValue) => (
      <option
        key={optionValue}
        value={optionValue}
      >
        {options[optionValue]}
      </option>
    ));
    return optionJSXArray;
  }

  render() {
    return (
      <select
        id={this.props.id}
        autoFocus={this.props.autofocus} // eslint-disable-line jsx-a11y/no-autofocus
        aria-labelledby={this.props.labelledBy}
        className={`form-control ${this.props.className}${this.props.invalid ? 'is-invalid' : ''}`}
        value={this.props.value}
        disabled={this.props.disabled}
        onChange={this.onChange}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
      >
        <option value="" disabled={this.props.disableNullOption}>--Select a Value--</option>
        {this.createOptions(this.props.options)}

      </select>
    );
  }
}

SelectAttribute.propTypes = {
  autofocus: PropTypes.bool,
  className: PropTypes.string,
  disableNullOption: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  invalid: PropTypes.bool,
  keyPath: PropTypes.array.isRequired,
  labelledBy: PropTypes.string,
  onFieldValueChange: PropTypes.func.isRequired,
  onFieldUIStateChange: PropTypes.func,
  options: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  sortOptions: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

SelectAttribute.defaultProps = {
  autofocus: false,
  className: '',
  disableNullOption: false,
  disabled: false,
  id: 'temp',
  invalid: false,
  labelledBy: '',
  onFieldUIStateChange: () => { },
  sortOptions: false,
  value: '',
};

export default SelectAttribute;
